import { render, staticRenderFns } from "./CreateEditTenant.vue?vue&type=template&id=3b440d12&scoped=true&"
import script from "./CreateEditTenant.vue?vue&type=script&lang=js&"
export * from "./CreateEditTenant.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditTenant.vue?vue&type=style&index=0&id=3b440d12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b440d12",
  null
  
)

export default component.exports